"use client";

import { Toaster } from "@unreserved/ui/components/sonner";

export default function SonnarToaster() {
  return <Toaster position="top-right" />;
}

